import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import GraphicsPageRightRail from '@components/pages/Graphics/GraphicsPage/RightRail';
import useGraphicsRelatedGraphics from '@hooks/useGraphicsRelatedGraphics';

import ArticleDetails from '../ArticleDetails';
import { PICTURE_CAPTION_CLASSES } from '../PictureCaption';
import { ThemeViewsProps } from '../interfaces';
import DataContent from './DataContent';

const Data = ({
  article: {
    addendum,
    advertisement,
    authors,
    commentsCount,
    commenters,
    featuredGraphic,
    freeBlurb,
    fullText,
    highlight,
    id,
    pickups,
    publishedAt,
    scriptList,
    subTitle,
    takeaway,
    title,
  },
  audioActive,
  canShareArticle,
  canViewFullArticle,
  canViewComments,
  clipperProps,
  endOfArticleDeepResearchPrompts,
  env,
  isSEOBotAndArticleIsNotFree,
  midArticleUnitType,
  newsletterId,
  relatedEvent,
  setAudioActive,
  suggestedAiPrompts,
}: ThemeViewsProps) => {
  const { relatedGraphics, isLoadingRelatedGraphicsResults } = useGraphicsRelatedGraphics(id);

  return (
    <div className="px-16 sm:px-28">
      <div className="relative m-auto max-w-container-lg">
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && canViewFullArticle,
          })}
        >
          <div className="flex flex-col-reverse md:flex-row md:gap-72 xl:gap-112">
            <div className="z-10 flex-1">
              <div className="mb-40 sm:mb-48 md:mb-64">
                <header className="mb-0 mt-16 border-0 border-b border-solid border-grayscale-gray pb-4">
                  <h1 className="m-0 font-suisse-neue text-body-lg font-normal text-primary-black">
                    {highlight}
                  </h1>
                </header>

                {featuredGraphic && canViewFullArticle && (
                  <div
                    className={clsx('mb-12 mt-32 sm:mt-56', {
                      'seo-paywall-content': isSEOBotAndArticleIsNotFree,
                    })}
                    data-nosnippet
                    aria-label={`${title} - ${subTitle}`}
                  >
                    {ReactHtmlParser(featuredGraphic)}
                  </div>
                )}

                <ArticleDetails
                  authors={authors}
                  commentsCount={commentsCount}
                  commenters={commenters}
                  publishedAt={publishedAt}
                  canShareArticle={canShareArticle}
                  articleId={id}
                  audioActive={audioActive}
                  setAudioActive={setAudioActive}
                />
              </div>
            </div>
            <div
              className={clsx(
                PICTURE_CAPTION_CLASSES,
                'hidden lg:block lg:w-[260px] lg:flex-shrink-0'
              )}
            >
              {!isLoadingRelatedGraphicsResults && canViewFullArticle && (
                <GraphicsPageRightRail
                  handleSearchTermChange={() => {}}
                  relatedGraphics={relatedGraphics}
                  searchQuery={''}
                />
              )}
            </div>
          </div>
          <DataContent
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            canViewFullArticle={canViewFullArticle}
            canViewComments={canViewComments}
            clipperProps={clipperProps}
            commentsCount={commentsCount}
            endOfArticleDeepResearchPrompts={endOfArticleDeepResearchPrompts}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            isSEOBotAndArticleIsNotFree={isSEOBotAndArticleIsNotFree}
            midArticleUnitType={midArticleUnitType}
            newsletterId={newsletterId}
            pickups={pickups}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            suggestedAiPrompts={suggestedAiPrompts}
            takeaway={takeaway}
          />
        </div>
      </div>
    </div>
  );
};

export default Data;
